import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import Dashboard from "@/components/ShopifyDashboard";
import Login from "@/components/Login";
import Layout from "@/components/Layout";
import LandingPage from "@/components/LandingPage";
import PrivacyPolicy from "@/components/PrivacyPolicy";
import { WhatsAppDemoLogin, WhatsAppDemoDashboard } from "@/components/WhatsAppDemo";
import WamerceDashboardV2, { WamerceComingSoon, WamerceInbox, WamerceInventory, WamerceSettings, WamerceSetupWizard } from "@/components/WamerceDashboardV2";
import WamerceWhatsApp from "@/components/WamerceWhatsApp";
import OnboardingWizard from "@/components/OnboardingWizard";
import MetaAdsManager from "@/components/MetaAdsManager";
import Inventory from "@/components/Inventory";
import InventoryOverview from "@/components/InventoryOverview";
import Orders from "@/components/ShopifyOrders";
import DraftsPage from "@/components/DraftsPage";
import DispatchTracker from "@/components/DispatchTracker";
import ConfirmationTracker from "@/components/ConfirmationTracker";
import PurchaseTracker from "@/components/PurchaseTracker";
import Reports from "@/components/Reports";
import Analytics from "@/components/Analytics";
import Settings from "@/components/Settings";
import WhatsAppMessaging from "@/components/WhatsAppMessaging";
import WhatsAppInbox from "@/components/WhatsAppInbox";
import WhatsAppTemplates from "@/components/WhatsAppTemplates";
import WhatsAppTemplateManager from "@/components/WhatsAppTemplateManager";
import WhatsAppCampaignManager from "@/components/WhatsAppCampaignManager";
import WhatsAppAnalytics from "@/components/WhatsAppAnalytics";
import TrackingPage from "@/components/TrackingPage";
import MarketingDashboard from "@/components/MarketingDashboard";
import FacebookMarketing from "@/components/FacebookMarketing";
import PerformanceComparison from "@/components/PerformanceComparison";
import InventoryCampaignManager from "@/components/InventoryCampaignManager";
import CampaignManager from "@/components/CampaignManager";
import FlashSaleManager from "@/components/FlashSaleManager";
import CustomerSegmentation from "@/components/CustomerSegmentation";
import CustomerSegmentationDashboard from "@/components/CustomerSegmentationDashboard";
import BundleCreator from "@/components/BundleCreator";
import DynamicPricingDashboard from "@/components/DynamicPricingDashboard";
import InventoryHealthDashboard from "@/components/InventoryHealthDashboard";
import FinanceReconciliation from "@/components/FinanceReconciliation";
import DTDCReconciliation from "@/components/DTDCReconciliation";
import DWZ56Shipping from "@/components/DWZ56Shipping";
import DTDCDashboard from "@/components/DTDCDashboard";
import DWZ56Purchase from "@/components/DWZ56Purchase";
import Products1688 from "@/components/Products1688";
import FulfillmentDashboard from "@/components/FulfillmentDashboard";
import ShopifyProducts from "@/components/ShopifyProducts";
import Purchase1688Orders from "@/components/Purchase1688Orders";
import ProductScraper from "@/components/ProductScraper";
import WhatsAppInboxStandalone from "@/components/WhatsAppInboxStandalone";
import ImageSearch from "@/components/ImageSearch";
import ProductCollector from "@/components/ProductCollector";
import WhatsAppEmbeddedSignup from "@/components/WhatsAppEmbeddedSignup";
import Alibaba1688Accounts from "@/components/Alibaba1688Accounts";
import InventoryClearance from "@/components/InventoryClearance";
import ProductApproval from "@/components/ProductApproval";
import UserManagement from "@/components/UserManagement";
import TmapiMonitor from "@/components/TmapiMonitor";
import ShopifyHistoricalSync from "@/components/ShopifyHistoricalSync";
import FulfillmentSync from "@/components/FulfillmentSync";
import FulfillmentPipeline from "@/components/FulfillmentPipeline";
import BulkOrder1688 from "@/components/BulkOrder1688";
import PricingPage from "@/components/PricingPage";
import NotificationSettings from "@/components/NotificationSettings";
import NotificationDashboard from "@/components/NotificationDashboard";
import NotificationPreferences from "@/components/NotificationPreferences";
import FacebookLeadAds from "@/components/FacebookLeadAds";
import SuperAdminDashboard from "@/components/SuperAdminDashboard";
import WhatsAppCaseStudy from "@/components/WhatsAppCaseStudy";
import StorefrontOrders from "@/components/StorefrontOrders";
import StorefrontCMS from "@/components/StorefrontCMS";
import StorefrontConfigManager from "@/components/StorefrontConfigManager";
import HeaderConfigManager from "@/components/HeaderConfigManager";
import BannerConfigManager from "@/components/BannerConfigManager";
import UnifiedStoreSettings from "@/components/UnifiedStoreSettings";
import SalesDashboard from "@/components/SalesDashboard";
import CheckoutPage from "@/components/CheckoutPage";
import MenuTagsManager from "@/components/MenuTagsManager";
import StoreManagement from "@/components/StoreManagement";
import SyncDashboard from "@/components/SyncDashboard";
import StockUpload from "@/components/StockUpload";
import SecurityLogs from "@/components/SecurityLogs";
import TaobaoImport from "@/components/TaobaoImport";
import WarehouseScanner from "@/components/WarehouseScanner";
import CompetitorDashboard from "@/components/CompetitorDashboard";
import CompetitorPriceCatalog from "@/components/CompetitorPriceCatalog";
import ScheduledPriceChecks from "@/components/ScheduledPriceChecks";
import AITools1688 from "@/components/AITools1688";
import DWZ56Tracking from "@/components/DWZ56Tracking";
import Merchants1688 from "@/components/Merchants1688";
import AIProductEditor from "@/components/AIProductEditor";
import ProductLinkManager from "@/components/ProductLinkManager";
import Trade1688Dashboard from "@/components/Trade1688Dashboard";
import MegaMenuBuilder from "@/components/MegaMenuBuilder";
import CartRecoveryDashboard from "@/components/CartRecoveryDashboard";
import ImageEnhancer from "@/components/ImageEnhancer";
import StoriesManager from "@/components/admin/StoriesManager";
// TNV Store Components (Namshi-inspired)
import { TNVStoreProvider, TNVHeader, TNVFooter } from "@/components/store/TNVStoreLayout";
import TNVHomePage from "@/components/store/TNVHomePage";
import TNVProductListing from "@/components/store/TNVProductListing";
import TNVProductDetail from "@/components/store/TNVProductDetail";
import TNVCart from "@/components/store/TNVCart";
import TNVCheckout from "@/components/store/TNVCheckout";
import TNVOrderConfirmation from "@/components/store/TNVOrderConfirmation";
// E-commerce Feature Components
import OrderTrackingPage from "@/components/store/OrderTrackingPage";
import WishlistPage from "@/components/store/WishlistPage";
import CustomerAccountPage from "@/components/store/CustomerAccountPage";
// Storefront Components
import { StorefrontLayout, CartProvider } from "@/components/storefront/StorefrontLayout";
import StorefrontHome from "@/components/storefront/StorefrontHome";
import ProductListing from "@/components/storefront/ProductListing";
import ProductDetail from "@/components/storefront/ProductDetail";
import ShoppingCart from "@/components/storefront/ShoppingCart";
import Checkout from "@/components/storefront/Checkout";
import OrderConfirmation from "@/components/storefront/OrderConfirmation";
import OrderTracking from "@/components/storefront/OrderTracking";
// Luxury Storefront Components (Stella McCartney Style)
import { LuxuryStorefrontLayout } from "@/components/storefront/LuxuryStorefrontLayout";
import LuxuryStorefrontHome from "@/components/storefront/LuxuryStorefrontHome";
import LuxuryProductListing from "@/components/storefront/LuxuryProductListing";
import LuxuryProductDetail from "@/components/storefront/LuxuryProductDetail";
import LuxuryShoppingCart from "@/components/storefront/LuxuryShoppingCart";
import LuxuryCheckout from "@/components/storefront/LuxuryCheckout";
import LuxuryOrderConfirmation from "@/components/storefront/LuxuryOrderConfirmation";
import LuxuryOrderTracking from "@/components/storefront/LuxuryOrderTracking";
import MobileAppPreview from "@/components/MobileAppPreview";
import MobileAppSettings from "@/components/MobileAppSettings";
import MobileAppEditorV2 from "@/components/MobileAppEditorV2";
import WebsiteEditorV2 from "@/components/WebsiteEditorV2";
import ShopifyStyleEditor from "@/components/ShopifyStyleEditor";
import MerchantOnboarding from "@/components/MerchantOnboarding";
import VPBXCallManager from "@/components/VPBXCallManager";
import LogisticsDashboard from "@/components/LogisticsDashboard";
// Legacy /store routes removed — storefront now lives in Hydrogen (/app/tnvhydrogen)
import { Toaster } from "@/components/ui/sonner";
import { Toaster as HotToaster } from "react-hot-toast";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { StoreProvider, useStore } from "@/contexts/StoreContext";
import ErrorBoundary from "@/components/ErrorBoundary";
import LoadingSpinner from "@/components/LoadingSpinner";

// Dynamic Storefront Wrapper for store-specific routes
function StorefrontWrapper({ page = 'home' }) {
  const { storeName, productId, orderId } = useParams();
  
  // Map store names to display names
  const storeDisplayNames = {
    'tnvcollection': 'TNC Collection',
    'tnvcollectionpk': 'TNC Collection PK'
  };
  
  const displayName = storeDisplayNames[storeName] || storeName;
  
  return (
    <StorefrontLayout storeName={displayName}>
      {page === 'home' && <StorefrontHome storeName={storeName} />}
      {page === 'listing' && <ProductListing storeName={storeName} />}
      {page === 'detail' && <ProductDetail storeName={storeName} />}
      {page === 'cart' && <ShoppingCart />}
      {page === 'checkout' && <Checkout storeName={storeName} />}
      {page === 'confirmation' && <OrderConfirmation />}
    </StorefrontLayout>
  );
}

// Luxury Storefront Wrapper (Stella McCartney Style)
function LuxuryStorefrontWrapper({ page = 'home' }) {
  return (
    <LuxuryStorefrontLayout>
      {page === 'home' && <LuxuryStorefrontHome />}
      {page === 'listing' && <LuxuryProductListing />}
      {page === 'detail' && <LuxuryProductDetail />}
      {page === 'cart' && <LuxuryShoppingCart />}
      {page === 'checkout' && <LuxuryCheckout />}
      {page === 'confirmation' && <LuxuryOrderConfirmation />}
      {page === 'tracking' && <LuxuryOrderTracking />}
    </LuxuryStorefrontLayout>
  );
}

import StoreOnboarding from "@/components/store/StoreOnboarding";
import { useLocation, useSearchParams } from 'react-router-dom';

// TNV Store Wrapper (Namshi-inspired) - Supports multi-store (tnvcollection for INR, tnvcollectionpk for PKR)
function TNVStoreWrapper({ children, storeName = "tnvcollection" }) {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const isEditorMode = searchParams.get('editor') === 'true';
  
  const [showOnboarding, setShowOnboarding] = useState(() => {
    // Skip onboarding in editor mode
    if (isEditorMode) return false;
    // Check if onboarding was completed
    return !localStorage.getItem(`${storeName}_onboarding_completed`);
  });
  
  // Check if we're on the homepage - it has its own header/footer
  const isHomePage = location.pathname === '/tnv' || location.pathname === '/tnv/';
  
  if (showOnboarding && !isEditorMode) {
    return (
      <StoreOnboarding 
        storeName={storeName}
        onComplete={() => setShowOnboarding(false)}
      />
    );
  }
  
  // Homepage in editor mode should show full layout with header
  if (isHomePage && isEditorMode) {
    return (
      <TNVStoreProvider storeName={storeName}>
        <TNVHeader />
        {children}
      </TNVStoreProvider>
    );
  }
  
  // Homepage has its own layout with bottom nav (no header)
  if (isHomePage) {
    return (
      <TNVStoreProvider storeName={storeName}>
        {children}
      </TNVStoreProvider>
    );
  }
  
  // Other pages use standard header/footer
  return (
    <TNVStoreProvider storeName={storeName}>
      <TNVHeader />
      <main className="min-h-screen">
        {children}
      </main>
      <TNVFooter />
    </TNVStoreProvider>
  );
}

// Pakistan Store Wrapper (PKR currency)
function TNVPKStoreWrapper({ children }) {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const isEditorMode = searchParams.get('editor') === 'true';
  
  const [showOnboarding, setShowOnboarding] = useState(() => {
    if (isEditorMode) return false;
    return !localStorage.getItem('tnvcollectionpk_onboarding_completed');
  });
  
  const isHomePage = location.pathname === '/tnv-pk' || location.pathname === '/tnv-pk/';
  
  if (showOnboarding && !isEditorMode) {
    return (
      <StoreOnboarding 
        storeName="tnvcollectionpk"
        onComplete={() => setShowOnboarding(false)}
      />
    );
  }
  
  if (isHomePage) {
    return (
      <TNVStoreProvider storeName="tnvcollectionpk">
        {children}
      </TNVStoreProvider>
    );
  }
  
  return (
    <TNVStoreProvider storeName="tnvcollectionpk">
      <TNVHeader />
      <main className="min-h-screen">
        {children}
      </main>
      <TNVFooter />
    </TNVStoreProvider>
  );
}

// Protected Route wrapper
function ProtectedRoute({ children }) {
  const { agent, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0f0f0f]">
        <LoadingSpinner text="Loading application..." size="large" />
      </div>
    );
  }
  
  if (!agent) {
    return <Navigate to="/login" replace />;
  }
  
  return <Layout>{children}</Layout>;
}

// V2 Protected Route — auth required but no legacy Layout (V2 pages bring their own WamerceShell)
function ProtectedV2Route({ children }) {
  const { agent, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <LoadingSpinner text="Loading Wamerce..." size="large" />
      </div>
    );
  }
  if (!agent) return <Navigate to="/login" replace />;
  return children;
}

// Protected Editor Route - Full screen without Layout sidebar for editors
function ProtectedEditorRoute({ children }) {
  const { agent, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <LoadingSpinner text="Loading editor..." size="large" />
      </div>
    );
  }
  
  if (!agent) {
    return <Navigate to="/login" replace />;
  }
  
  // Return children directly without Layout wrapper for full-screen editors
  return children;
}

// Login Route wrapper
function LoginRoute() {
  const { agent, login } = useAuth();
  
  if (agent) {
    return <Navigate to="/dashboard" replace />;
  }
  
  return <Login onLoginSuccess={login} />;
}

// Landing page route - shows landing for non-auth, redirects to dashboard for auth
function LandingRoute() {
  const { agent, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0a0a0a]">
        <LoadingSpinner text="Loading..." size="large" />
      </div>
    );
  }
  
  if (agent) {
    return <Navigate to="/dashboard" replace />;
  }
  
  return <LandingPage />;
}

// NotificationDashboard wrapper that gets store from context
function NotificationDashboardWrapper() {
  const { selectedStore, getStoreName } = useStore();
  const storeName = selectedStore && selectedStore !== 'all' ? selectedStore : '';
  
  return <NotificationDashboard storeName={storeName} />;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<LandingRoute />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/whatsapp/login" element={<WhatsAppDemoLogin />} />
      <Route path="/whatsapp/dashboard" element={<WhatsAppDemoDashboard />} />
      <Route path="/v2" element={<ProtectedV2Route><WamerceDashboardV2 /></ProtectedV2Route>} />
      <Route path="/v2/dashboard" element={<ProtectedV2Route><WamerceDashboardV2 /></ProtectedV2Route>} />
      <Route path="/v2/inbox" element={<ProtectedV2Route><WamerceInbox /></ProtectedV2Route>} />
      <Route path="/v2/inventory" element={<ProtectedV2Route><WamerceInventory /></ProtectedV2Route>} />
      <Route path="/v2/whatsapp" element={<ProtectedV2Route><WamerceWhatsApp /></ProtectedV2Route>} />
      <Route path="/v2/instagram" element={<ProtectedV2Route><WamerceComingSoon section="instagram" /></ProtectedV2Route>} />
      <Route path="/v2/facebook" element={<ProtectedV2Route><WamerceComingSoon section="facebook" /></ProtectedV2Route>} />
      <Route path="/v2/others" element={<ProtectedV2Route><WamerceComingSoon section="others" /></ProtectedV2Route>} />
      <Route path="/v2/settings" element={<ProtectedV2Route><WamerceSettings /></ProtectedV2Route>} />
      <Route path="/v2/setup/:stepId" element={<ProtectedV2Route><WamerceSetupWizard /></ProtectedV2Route>} />
      <Route path="/login" element={<LoginRoute />} />
      <Route path="/mobile-app-preview" element={<MobileAppPreview />} />
      <Route path="/mobile-app-editor" element={<ProtectedEditorRoute><MobileAppEditorV2 /></ProtectedEditorRoute>} />
      <Route path="/website-editor" element={<ProtectedEditorRoute><WebsiteEditorV2 /></ProtectedEditorRoute>} />
      <Route path="/theme-editor" element={<ProtectedEditorRoute><ShopifyStyleEditor /></ProtectedEditorRoute>} />
      <Route path="/image-enhancer" element={<ProtectedRoute><ImageEnhancer /></ProtectedRoute>} />
      <Route path="/stories-manager" element={<ProtectedRoute><StoriesManager /></ProtectedRoute>} />
      <Route path="/onboarding" element={<ProtectedRoute><OnboardingWizard /></ProtectedRoute>} />
      <Route path="/create-store" element={<MerchantOnboarding />} />
      <Route path="/merchant-onboarding" element={<MerchantOnboarding />} />
      <Route 
        path="/vpbx-calls" 
        element={
          <ProtectedRoute>
            <VPBXCallManager />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/logistics" 
        element={
          <ProtectedRoute>
            <LogisticsDashboard />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/dashboard" 
        element={
          <ProtectedV2Route>
            <WamerceDashboardV2 />
          </ProtectedV2Route>
        } 
      />
      <Route 
        path="/legacy/dashboard" 
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/meta-ads" 
        element={
          <ProtectedRoute>
            <MetaAdsManager />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/customers" 
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/orders" 
        element={
          <ProtectedRoute>
            <Orders />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/drafts" 
        element={
          <ProtectedRoute>
            <DraftsPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/tracker" 
        element={
          <ProtectedRoute>
            <DispatchTracker />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/dispatch-tracker" 
        element={
          <ProtectedRoute>
            <DispatchTracker />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/confirmation" 
        element={
          <ProtectedRoute>
            <ConfirmationTracker />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/purchase" 
        element={
          <ProtectedRoute>
            <PurchaseTracker />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/inventory" 
        element={
          <ProtectedRoute>
            <Inventory />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/inventory-overview" 
        element={
          <ProtectedRoute>
            <InventoryOverview />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/product-approval" 
        element={
          <ProtectedRoute>
            <ProductApproval />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/marketing" 
        element={
          <ProtectedRoute>
            <MarketingDashboard />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/facebook-marketing" 
        element={
          <ProtectedRoute>
            <FacebookMarketing />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/performance-comparison" 
        element={
          <ProtectedRoute>
            <PerformanceComparison />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/campaigns" 
        element={
          <ProtectedRoute>
            <CampaignManager />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/flash-sales" 
        element={
          <ProtectedRoute>
            <FlashSaleManager />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/segments" 
        element={
          <ProtectedRoute>
            <CustomerSegmentationDashboard />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/bundles" 
        element={
          <ProtectedRoute>
            <BundleCreator />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/reports" 
        element={
          <ProtectedRoute>
            <Reports />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/analytics" 
        element={
          <ProtectedRoute>
            <Analytics />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/settings" 
        element={
          <ProtectedRoute>
            <Settings />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/whatsapp" 
        element={
          <ProtectedRoute>
            <WhatsAppMessaging />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/whatsapp-inbox" 
        element={
          <ProtectedRoute>
            <WhatsAppInbox />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/inbox" 
        element={<WhatsAppInboxStandalone />} 
      />
      <Route 
        path="/whatsapp-templates" 
        element={
          <ProtectedRoute>
            <WhatsAppTemplateManager />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/whatsapp-campaigns" 
        element={
          <ProtectedRoute>
            <WhatsAppCampaignManager />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/whatsapp-analytics" 
        element={
          <ProtectedRoute>
            <WhatsAppAnalytics />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/whatsapp-business" 
        element={
          <ProtectedRoute>
            <WhatsAppEmbeddedSignup />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/whatsapp-notifications" 
        element={
          <ProtectedRoute>
            <NotificationDashboardWrapper />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/tracking/:identifier" 
        element={<TrackingPage />}
      />
      <Route 
        path="/dynamic-pricing" 
        element={
          <ProtectedRoute>
            <DynamicPricingDashboard />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/inventory-health" 
        element={
          <ProtectedRoute>
            <InventoryHealthDashboard />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/finance-reconciliation" 
        element={
          <ProtectedRoute>
            <FinanceReconciliation />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/dtdc-reconciliation" 
        element={
          <ProtectedRoute>
            <DTDCReconciliation />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/dtdc-shipping" 
        element={
          <ProtectedRoute>
            <DTDCDashboard />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/dwz56-shipping" 
        element={
          <ProtectedRoute>
            <DWZ56Shipping />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/dwz56-purchase" 
        element={
          <ProtectedRoute>
            <DWZ56Purchase />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/1688-products" 
        element={
          <ProtectedRoute>
            <Products1688 />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/1688-merchants" 
        element={
          <ProtectedRoute>
            <Merchants1688 />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/1688-trade" 
        element={
          <ProtectedRoute>
            <Trade1688Dashboard />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/1688-trade-center" 
        element={
          <ProtectedRoute>
            <Trade1688Dashboard />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/ai-product-editor" 
        element={
          <ProtectedRoute>
            <AIProductEditor />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/product-link-manager" 
        element={
          <ProtectedRoute>
            <ProductLinkManager />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/fulfillment" 
        element={
          <ProtectedRoute>
            <FulfillmentDashboard />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/products" 
        element={
          <ProtectedRoute>
            <ShopifyProducts />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/purchase-1688" 
        element={
          <ProtectedRoute>
            <Purchase1688Orders />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/product-scraper" 
        element={
          <ProtectedRoute>
            <ProductScraper />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/image-search" 
        element={
          <ProtectedRoute>
            <ImageSearch />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/product-collector" 
        element={
          <ProtectedRoute>
            <ProductCollector />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/1688-accounts" 
        element={
          <ProtectedRoute>
            <Alibaba1688Accounts />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/inventory-clearance" 
        element={
          <ProtectedRoute>
            <InventoryClearance />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/users" 
        element={
          <ProtectedRoute>
            <UserManagement />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/shopify-sync" 
        element={
          <ProtectedRoute>
            <ShopifyHistoricalSync />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/fulfillment-sync" 
        element={
          <ProtectedRoute>
            <FulfillmentSync />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/fulfillment-pipeline" 
        element={
          <ProtectedRoute>
            <FulfillmentPipeline />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/dwz56-tracking" 
        element={
          <ProtectedRoute>
            <DWZ56Tracking />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/storefront-orders" 
        element={
          <ProtectedRoute>
            <StorefrontOrders />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/storefront-config" 
        element={
          <ProtectedRoute>
            <StorefrontConfigManager />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/header-config" 
        element={
          <ProtectedRoute>
            <HeaderConfigManager />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/banner-config" 
        element={
          <ProtectedRoute>
            <BannerConfigManager />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/store-settings" 
        element={
          <ProtectedRoute>
            <UnifiedStoreSettings />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/sales-dashboard" 
        element={
          <ProtectedRoute>
            <SalesDashboard />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/mega-menu-builder" 
        element={
          <ProtectedRoute>
            <MegaMenuBuilder />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/cart-recovery" 
        element={
          <ProtectedRoute>
            <CartRecoveryDashboard />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/mobile-app-settings" 
        element={
          <ProtectedRoute>
            <MobileAppSettings />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/mobile-push-notifications" 
        element={
          <ProtectedRoute>
            <MobileAppSettings />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/mobile-app-preview" 
        element={
          <ProtectedRoute>
            <MobileAppPreview />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/mobile-app-theme" 
        element={
          <ProtectedRoute>
            <MobileAppSettings />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/mobile-app-features" 
        element={
          <ProtectedRoute>
            <MobileAppSettings />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/checkout" 
        element={<CheckoutPage />}
      />
      <Route 
        path="/tnv/checkout" 
        element={<CheckoutPage />}
      />
      <Route 
        path="/menu-tags" 
        element={
          <ProtectedRoute>
            <MenuTagsManager />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/store-management" 
        element={
          <ProtectedRoute>
            <StoreManagement />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/storefront-cms" 
        element={
          <ProtectedRoute>
            <StorefrontCMS />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/bulk-order-1688" 
        element={
          <ProtectedRoute>
            <BulkOrder1688 />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/sync-dashboard" 
        element={
          <ProtectedRoute>
            <SyncDashboard />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/pricing" 
        element={
          <ProtectedRoute>
            <PricingPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/notifications" 
        element={
          <ProtectedRoute>
            <NotificationSettings />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/lead-ads" 
        element={
          <ProtectedRoute>
            <FacebookLeadAds />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/super-admin" 
        element={
          <ProtectedRoute>
            <SuperAdminDashboard />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/whatsapp-case-study" 
        element={<WhatsAppCaseStudy />}
      />
      <Route 
        path="/tmapi-monitor" 
        element={
          <ProtectedRoute>
            <TmapiMonitor />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/stock-upload" 
        element={
          <ProtectedRoute>
            <StockUpload />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/security-logs" 
        element={
          <ProtectedRoute>
            <SecurityLogs />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/taobao-import" 
        element={
          <ProtectedRoute>
            <TaobaoImport />
          </ProtectedRoute>
        } 
      />
      
      {/* Warehouse Scanner - PIN Protected (No Login Required) */}
      <Route 
        path="/warehouse" 
        element={<WarehouseScanner />} 
      />
      <Route 
        path="/warehouse/scan" 
        element={<WarehouseScanner />} 
      />
      
      {/* Competitor Price Dashboard */}
      <Route 
        path="/competitor-dashboard" 
        element={
          <ProtectedRoute>
            <CompetitorDashboard />
          </ProtectedRoute>
        } 
      />

      {/* Competitor Price Catalog - Product Comparison View */}
      <Route 
        path="/price-comparison" 
        element={
          <ProtectedRoute>
            <CompetitorPriceCatalog />
          </ProtectedRoute>
        } 
      />

      {/* Scheduled Price Checks */}
      <Route 
        path="/scheduled-price-checks" 
        element={
          <ProtectedRoute>
            <ScheduledPriceChecks />
          </ProtectedRoute>
        } 
      />

      {/* 1688 AI Tools - Translation & Title Generation */}
      <Route 
        path="/1688-ai-tools" 
        element={
          <ProtectedRoute>
            <AITools1688 />
          </ProtectedRoute>
        } 
      />
      
      {/* Public Storefront Routes - No Auth Required */}
      <Route 
        path="/shop" 
        element={
          <StorefrontLayout storeName="TNC Collection">
            <StorefrontHome storeName="tnvcollection" />
          </StorefrontLayout>
        } 
      />
      <Route 
        path="/shop/products" 
        element={
          <StorefrontLayout storeName="TNC Collection">
            <ProductListing storeName="tnvcollection" />
          </StorefrontLayout>
        } 
      />
      <Route 
        path="/shop/product/:productId" 
        element={
          <StorefrontLayout storeName="TNC Collection">
            <ProductDetail storeName="tnvcollection" />
          </StorefrontLayout>
        } 
      />
      <Route 
        path="/shop/cart" 
        element={
          <StorefrontLayout storeName="TNC Collection">
            <ShoppingCart />
          </StorefrontLayout>
        } 
      />
      <Route 
        path="/shop/checkout" 
        element={
          <StorefrontLayout storeName="TNC Collection">
            <Checkout storeName="tnvcollection" />
          </StorefrontLayout>
        } 
      />
      <Route 
        path="/shop/order-confirmation/:orderId" 
        element={
          <StorefrontLayout storeName="TNC Collection">
            <OrderConfirmation />
          </StorefrontLayout>
        } 
      />
      <Route 
        path="/shop/track" 
        element={
          <StorefrontLayout storeName="TNC Collection">
            <OrderTracking />
          </StorefrontLayout>
        } 
      />
      <Route 
        path="/shop/track/:orderId" 
        element={
          <StorefrontLayout storeName="TNC Collection">
            <OrderTracking />
          </StorefrontLayout>
        } 
      />
      <Route 
        path="/shop/:category" 
        element={
          <StorefrontLayout storeName="TNC Collection">
            <ProductListing storeName="tnvcollection" />
          </StorefrontLayout>
        } 
      />
      
      {/* Store-Specific Storefront Routes - Using Luxury Layout (Stella McCartney Style) */}
      <Route 
        path="/store/:storeSlug" 
        element={<LuxuryStorefrontWrapper />} 
      />
      <Route 
        path="/store/:storeSlug/products" 
        element={<LuxuryStorefrontWrapper page="listing" />} 
      />
      <Route 
        path="/store/:storeSlug/product/:productId" 
        element={<LuxuryStorefrontWrapper page="detail" />} 
      />
      <Route 
        path="/store/:storeSlug/cart" 
        element={<LuxuryStorefrontWrapper page="cart" />} 
      />
      <Route 
        path="/store/:storeSlug/checkout" 
        element={<LuxuryStorefrontWrapper page="checkout" />} 
      />
      <Route 
        path="/store/:storeSlug/order-confirmation/:orderId" 
        element={<LuxuryStorefrontWrapper page="confirmation" />} 
      />
      <Route 
        path="/store/:storeSlug/track" 
        element={<LuxuryStorefrontWrapper page="tracking" />} 
      />

      {/* TNV storefront moved to Hydrogen — served from tnvcollection.com */}

      {/* TNV Store Routes - Namshi-inspired Design */}
      <Route path="/tnv" element={<TNVStoreWrapper><TNVHomePage /></TNVStoreWrapper>} />
      <Route path="/tnv/products" element={<TNVStoreWrapper><TNVProductListing /></TNVStoreWrapper>} />
      <Route path="/tnv/:category" element={<TNVStoreWrapper><TNVProductListing /></TNVStoreWrapper>} />
      <Route path="/tnv/:category/:subcategory" element={<TNVStoreWrapper><TNVProductListing /></TNVStoreWrapper>} />
      <Route path="/tnv/product/:productId" element={<TNVStoreWrapper><TNVProductDetail /></TNVStoreWrapper>} />
      <Route path="/tnv/collection/:collectionId" element={<TNVStoreWrapper><TNVProductListing /></TNVStoreWrapper>} />
      <Route path="/tnv/brand/:brandName" element={<TNVStoreWrapper><TNVProductListing /></TNVStoreWrapper>} />
      <Route path="/tnv/category/:categoryName" element={<TNVStoreWrapper><TNVProductListing /></TNVStoreWrapper>} />
      <Route path="/tnv/cart" element={<TNVStoreWrapper><TNVCart /></TNVStoreWrapper>} />
      <Route path="/tnv/checkout" element={<TNVStoreWrapper><TNVCheckout /></TNVStoreWrapper>} />
      <Route path="/tnv/order-confirmation/:orderId" element={<TNVStoreWrapper><TNVOrderConfirmation /></TNVStoreWrapper>} />
      <Route path="/tnv/track/:orderId" element={<TNVStoreWrapper><OrderTrackingPage /></TNVStoreWrapper>} />
      <Route path="/tnv/track" element={<TNVStoreWrapper><OrderTrackingPage /></TNVStoreWrapper>} />
      <Route path="/tnv/wishlist" element={<TNVStoreWrapper><WishlistPage /></TNVStoreWrapper>} />
      <Route path="/tnv/account" element={<TNVStoreWrapper><CustomerAccountPage /></TNVStoreWrapper>} />
      
      {/* TNV Pakistan Store Routes (PKR Currency) */}
      <Route path="/tnv-pk" element={<TNVPKStoreWrapper><TNVHomePage /></TNVPKStoreWrapper>} />
      <Route path="/tnv-pk/products" element={<TNVPKStoreWrapper><TNVProductListing /></TNVPKStoreWrapper>} />
      <Route path="/tnv-pk/:category" element={<TNVPKStoreWrapper><TNVProductListing /></TNVPKStoreWrapper>} />
      <Route path="/tnv-pk/:category/:subcategory" element={<TNVPKStoreWrapper><TNVProductListing /></TNVPKStoreWrapper>} />
      <Route path="/tnv-pk/product/:productId" element={<TNVPKStoreWrapper><TNVProductDetail /></TNVPKStoreWrapper>} />
      <Route path="/tnv-pk/collection/:collectionId" element={<TNVPKStoreWrapper><TNVProductListing /></TNVPKStoreWrapper>} />
      <Route path="/tnv-pk/brand/:brandName" element={<TNVPKStoreWrapper><TNVProductListing /></TNVPKStoreWrapper>} />
      <Route path="/tnv-pk/category/:categoryName" element={<TNVPKStoreWrapper><TNVProductListing /></TNVPKStoreWrapper>} />
      <Route path="/tnv-pk/cart" element={<TNVPKStoreWrapper><TNVCart /></TNVPKStoreWrapper>} />
      <Route path="/tnv-pk/checkout" element={<TNVPKStoreWrapper><TNVCheckout /></TNVPKStoreWrapper>} />
      <Route path="/tnv-pk/order-confirmation/:orderId" element={<TNVPKStoreWrapper><TNVOrderConfirmation /></TNVPKStoreWrapper>} />
      <Route path="/tnv-pk/track/:orderId" element={<TNVPKStoreWrapper><OrderTrackingPage /></TNVPKStoreWrapper>} />
      <Route path="/tnv-pk/track" element={<TNVPKStoreWrapper><OrderTrackingPage /></TNVPKStoreWrapper>} />
      <Route path="/tnv-pk/wishlist" element={<TNVPKStoreWrapper><WishlistPage /></TNVPKStoreWrapper>} />
      <Route path="/tnv-pk/account" element={<TNVPKStoreWrapper><CustomerAccountPage /></TNVPKStoreWrapper>} />
    </Routes>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <div className="App">
        <AuthProvider>
          <StoreProvider>
            <BrowserRouter>
              <AppRoutes />
            </BrowserRouter>
            <Toaster position="top-right" />
            <HotToaster position="top-right" />
          </StoreProvider>
        </AuthProvider>
      </div>
    </ErrorBoundary>
  );
}

export default App;